module.exports = __webpack_public_path__ + "img/Picture10.18455089.png";